import React from 'react';
import { Form, Input } from 'antd';

const CustomerMessage = () => {
    const { TextArea } = Input;
    return (
        <Form.Item label="Wiadomość w mailu" name="customerMessage">
            <TextArea
                placeholder="Dodatkowa wiadomość do klienta w mailu potwierdzającym rezerwację"
                autoSize={{
                    minRows: 2,
                    maxRows: 6,
                }}
            />
        </Form.Item>
    );
};

export default CustomerMessage;
